import React, { useEffect } from "react";
import { Close } from "@mui/icons-material";

export const FIELD_CLASS =
  "w-full px-4 py-3 border-b-2 border-gray-300 focus:border-teal-500 outline-none transition-colors bg-transparent disabled:opacity-50 disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed";

export const LABEL_CLASS = "block text-sm font-semibold text-gray-700 mb-2";

const SIZE_CLASS = {
  sm: "max-w-md",
  md: "max-w-lg",
  lg: "max-w-3xl",
  xl: "max-w-5xl"
};

const Modal = ({
  open,
  title,
  onClose,
  children,
  footer,
  size = "lg",
  closeOnBackdrop = true
}) => {
  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center sm:p-4 bg-black/40 backdrop-blur-sm"
      onClick={() => {
        if (closeOnBackdrop) onClose?.();
      }}
    >
      <div
        className={`w-full ${SIZE_CLASS[size] || SIZE_CLASS.lg} max-h-[92dvh] sm:max-h-[90dvh] rounded-t-3xl sm:rounded-2xl bg-white shadow-2xl border border-gray-200 overflow-hidden flex flex-col`}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <div className="px-5 py-4 sm:px-6 bg-gradient-to-r from-teal-900 via-teal-800 to-teal-700 text-white flex items-center justify-between gap-3 shrink-0">
          <h3 id="modal-title" className="text-lg font-semibold truncate">
            {title}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex shrink-0 items-center justify-center rounded-full p-2 -mr-1 hover:bg-white/10"
            aria-label="Close"
          >
            <Close sx={{ fontSize: 22 }} />
          </button>
        </div>

        <div
          className={`min-h-0 flex-1 overflow-y-auto overflow-x-hidden overscroll-contain px-5 py-5 sm:p-6 ${
            footer ? "" : "pb-[max(1.25rem,env(safe-area-inset-bottom))]"
          }`}
        >
          {children}
        </div>

        {footer ? (
          <div className="px-5 sm:px-6 pt-3 sm:py-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] border-t border-gray-200 bg-gray-50 flex flex-wrap justify-end gap-3 shrink-0 [&>*]:flex-1 sm:[&>*]:flex-none">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Modal;
